var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form record-picker-popup"
  }, [_c('div', {
    staticClass: "content-form-popup record-picker-content"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('modal-close-button', {
    attrs: {
      "aria-label": "Zavrieť výdavky"
    },
    on: {
      "click": _vm.closeDialog
    }
  }), _c('div', {
    staticClass: "_900 big"
  }, [_vm._v(_vm._s(_vm.dialogTitle))])], 1), _vm.clientInfo ? _c('div', {
    staticClass: "header-block inline"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.clientInfo.type))]), _c('img', {
    staticClass: "image-10",
    attrs: {
      "src": _vm.getIcon(_vm.clientInfo.type),
      "loading": "lazy",
      "alt": ""
    }
  })]) : _vm._e(), _vm.showTabs ? _c('record-picker-tabs', {
    attrs: {
      "registered-count": _vm.debtsGetter.length,
      "aria-label": "Sekcie výdavkov"
    },
    model: {
      value: _vm.activeSection,
      callback: function callback($$v) {
        _vm.activeSection = $$v;
      },
      expression: "activeSection"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "w-form"
  }, [_c('div', {
    staticClass: "form-2",
    attrs: {
      "id": "email-form"
    }
  }, [_vm.activeSection === 'registered' ? _c('section', {
    staticClass: "picker-section"
  }, [_c('div', {
    staticClass: "section-intro"
  }, [_c('div', {
    staticClass: "section-intro-title"
  }, [_vm._v("Evidované výdavky")]), _vm.type === 'classic' ? _c('div', {
    staticClass: "section-intro-copy"
  }, [_vm._v(" Pri každom úvere nastavte, či sa ponechá, splatí pred čerpaním alebo refinancuje. ")]) : _vm.type === 'refinancovane' ? _c('div', {
    staticClass: "section-intro-copy"
  }, [_vm._v(" Vyberte výdavok, ktorý sa má splatiť novou hypotékou. ")]) : _vm._e()]), _vm._l(_vm.debtsGetter, function (debt) {
    return _c('div', {
      key: debt.id,
      staticClass: "record-card",
      "class": _vm.debtPlanClass(debt)
    }, [_c('div', {
      staticClass: "record-main"
    }, [_c('div', {
      staticClass: "record-name"
    }, [_vm._v(" " + _vm._s(_vm.translateDebtType(debt.typ)) + " "), debt.banka ? _c('strong', [_vm._v(_vm._s(_vm.translateBank(debt.banka)))]) : _vm._e(), debt.cislo_uveru ? _c('span', {
      staticClass: "record-type"
    }, [_vm._v("č. " + _vm._s(debt.cislo_uveru))]) : _vm._e()]), debt.loading && _vm.updatingDebtId !== debt.id ? _c('v-progress-circular', {
      staticClass: "loading-spinner extrasmall",
      attrs: {
        "indeterminate": ""
      }
    }) : _c('div', {
      staticClass: "record-amount"
    }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.debtAmount(debt))) + " EUR")])], 1), debt.error ? _c('div', {
      staticClass: "record-warning"
    }, [_vm._v(" Výdavok treba dokončiť, aby sa dal správne vypočítať. ")]) : _vm._e(), _c('div', {
      staticClass: "record-actions",
      "class": {
        single: _vm.type === 'pickerOnly'
      }
    }, [_vm.type !== 'pickerOnly' ? _c('div', {
      staticClass: "record-management"
    }, [_c('button', {
      staticClass: "record-edit",
      attrs: {
        "type": "button",
        "disabled": _vm.updatingDebtId === debt.id
      },
      on: {
        "click": function click($event) {
          return _vm.edit(debt);
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "size": 17
      }
    }), _vm._v(" " + _vm._s(debt.error ? "Dokončiť" : "Upraviť") + " ")], 1), debt.can_delete !== false ? _c('button', {
      staticClass: "record-delete",
      attrs: {
        "type": "button",
        "disabled": _vm.updatingDebtId === debt.id
      },
      on: {
        "click": function click($event) {
          return _vm.removeDebt(debt);
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "trash",
        "size": 17
      }
    }), _vm._v(" Zmazať ")], 1) : _c('div', {
      staticClass: "record-delete-locked"
    }, [_vm._v(" " + _vm._s(debt.delete_block_reason) + " ")])]) : _vm._e(), _vm.type === 'classic' ? _c('debt-plan-selector', {
      attrs: {
        "value": _vm.debtPlan(debt),
        "busy": _vm.updatingDebtId === debt.id
      },
      on: {
        "change": function change($event) {
          return _vm.changeDebtPlan(debt, $event);
        }
      }
    }) : _vm.type === 'refinancovane' ? _c('button', {
      staticClass: "record-select",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.pick(debt);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.debtPlan(debt) === "refinance" ? "Refinancuje sa" : "Refinancovať") + " ")]) : _c('button', {
      staticClass: "record-select",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.pick(debt);
        }
      }
    }, [_vm._v(" Vybrať ")])], 1)]);
  }), _vm.debtsGetter.length === 0 ? _c('div', {
    staticClass: "empty-records"
  }, [_c('div', {
    staticClass: "empty-records-icon"
  }, [_c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 22
    }
  })], 1), _c('div', {
    staticClass: "empty-records-title"
  }, [_vm._v("Zatiaľ tu nie je žiadny výdavok")]), _c('div', {
    staticClass: "empty-records-copy"
  }, [_vm._v("Pridajte prvý výdavok klienta a aplikácia ho zahrnie do výpočtov.")]), _vm.showTabs ? _c('button', {
    staticClass: "empty-records-action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.activeSection = 'new';
      }
    }
  }, [_vm._v(" Pridať výdavok ")]) : _vm._e()]) : _vm._e()], 2) : _c('section', {
    staticClass: "picker-section new-record-section"
  }, [_vm._m(0), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.debtTypePicker('hypoteka');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("hypotéka")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.debtTypePicker('povolene_precerpanie');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("povolené prečerpanie")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.debtTypePicker('leasing');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("leasing")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.debtTypePicker('kreditna_karta');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("kreditná karta")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.debtTypePicker('spotrebny_uver');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("spotrebný úver")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1)])])])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "splitter"
  }, [_vm._v("Vyberte typ "), _c('strong', [_vm._v("výdavku")])]);

}]

export { render, staticRenderFns }